import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Card
} from 'semantic-ui-react';
import { userConstants } from '../../constants/user.constants';
import { settingsActions } from '../../actions/settings.actions';
import variant from '../../variant';

class ReportIndexScreen extends Component {
  componentDidMount() {
    this.props.dispatch(settingsActions.fetchGlobal());
  }

  render() {
    const { me, settings } = this.props;
    // MANAGER/APPROVER/USER_MANAGER only see the manager-scoped access/activity reports below when this is on -
    // ADMIN is unaffected (already bypasses via the Role check on each card).
    const managerAccessLogsAllowed = !!settings?.AllowManagerAccessLogs;

    return (
      <Fragment>
      <h1>Relatórios</h1>        
      <h2>Solicitações</h2>
        <Card.Group itemsPerRow={3}>
            <Card 
                href='#/report/request-manager' 
                header='Solicitações por Gestor'
                description='Quantidade de solicitações e horas por gestor'>                
            </Card>
            <Card 
                href='#/report/request-user' 
                header='Solicitações por Usuário'
                description='Quantidade de solicitações e horas por usuário'>                
            </Card>
            <Card
                href='#/report/request-all'
                header='Solicitações'
                description='Relatório completo de todas as solicitações do sistema'>
            </Card>
            {me && (me.Role == userConstants.ROLE_ADMIN || (me.permissions?.includes("report.approvedrequests.fetch") && managerAccessLogsAllowed)) && <Card
                href='#/report/approved-requests'
                header='Solicitações Aprovadas'
                description='Solicitações aprovadas por usuário, restrito aos usuários que o gestor pode aprovar'>
            </Card>}
        </Card.Group>
      <h2>Jornada de Trabalho</h2>
        <Card.Group itemsPerRow={3}>
            <Card 
                href='#/userlock/notifications' 
                header='Acessos'
                description='Relatório de ações dos usuários nas estações de trabalho'>                
            </Card>
            <Card
                href='#/report/work-journey'
                header='Histórico Jornada'
                description='Histórico da Jornada de trabalho por dia'>
            </Card>
            {me && (me.Role == userConstants.ROLE_ADMIN || (me.permissions?.includes("report.sessions.fetch") && managerAccessLogsAllowed)) && <Card
                href='#/report/sessions'
                header='Sessões (Gestor)'
                description='Tempo ativo e bloqueado por usuário, restrito aos usuários que o gestor pode aprovar'>
            </Card>}
            {me && (me.Role == userConstants.ROLE_ADMIN || (me.permissions?.includes("report.outsidejourney.fetch") && managerAccessLogsAllowed)) && <Card
                href='#/report/access-outside-journey'
                header='Acessos Fora da Jornada'
                description='Eventos de logon/desbloqueio fora da jornada de trabalho, restrito aos usuários que o gestor pode aprovar'>
            </Card>}
            {me && (me.Role == userConstants.ROLE_ADMIN  || me.permissions?.includes("report.contact.fetch")) && <Card
                href='#/report/activity-interval'
                header='Sessões e Bloqueios'
                description='Relatório com tempos de sessão e bloqueio por usuário'>
            </Card>}
            {variant.features.activityTracking && me && (me.Role == userConstants.ROLE_ADMIN || me.Role == userConstants.ROLE_AUDIT) && <Card
                href='#/report/user-activity'
                header='Atividade de Aplicativos'
                description='Tempo ativo e ocioso por aplicativo, usuário e máquina'>
            </Card>}
            {variant.features.activityTracking && me && (me.Role == userConstants.ROLE_ADMIN || me.Role == userConstants.ROLE_AUDIT) && <Card
                href='#/report/app-activity-summary'
                header='Atividade de Aplicativos por Dia'
                description='Tempo ativo e ocioso agregados por usuário, aplicativo e dia'>
            </Card>}
            {me && (me.Role == userConstants.ROLE_ADMIN  || me.permissions?.includes("report.contact.fetch")) && <Card
                href='#/report/activity-summary'
                header='Resumo de Sessões'
                description='Tempos de sessão ativa e bloqueio agregados por usuário e dia'>
            </Card>}
            {me && (me.Role == userConstants.ROLE_ADMIN  || me.permissions?.includes("report.contact.fetch")) && <Card
                href='#/report/activity-dashboard'
                header='Analytics Sessões'
                description='Gráficos de tempos de sessão, bloqueios e solicitações'>
            </Card>}
            {me && (me.Role == userConstants.ROLE_ADMIN || me.permissions?.includes("notification.fetch")) && <Card 
                href='#/notification/log' 
                header='Notificações'
                description='Notificações Popup enviadas para os usuários'>                
            </Card>}
            {me && (me.Role == userConstants.ROLE_ADMIN  || me.permissions?.includes("report.contact.fetch")) && <Card
                href='#/report/last-contact'
                header='Último Contato'
                description='Data de último contato recebido dos agentes dos usuários'>
            </Card>}
            {variant.features.menuTerms && me && me.Role == userConstants.ROLE_ADMIN && <Card
                href='#/report/term-acceptances'
                header='Aceite de Termos'
                description='Registro de aceite dos termos de uso pelos usuários'>
            </Card>}
        </Card.Group>
      {me && (me.Role == userConstants.ROLE_ADMIN  || me.permissions?.includes("report.auth.fetch")) && <Fragment>
        <h2>Integrações</h2>
        <Card.Group itemsPerRow={3}>
            <Card 
                href='#/report/integration-log' 
                header='Logs Integração'
                description='Relatório de logs de integração com sistema de RH e Ponto'>                
            </Card>
            <Card
                href='#/report/auth'
                header='Logs Autenticação'
                description='Relatório de acessos de usuário no sistema'>
            </Card>
            <Card
                href='#/report/mail-log'
                header='Histórico de E-mails'
                description='Relatório dos e-mails enviados pelo sistema e das falhas de envio'>
            </Card>
            <Card 
                href='#/report/audit-user' 
                header='Auditoria Usuários'
                description='Relatório de auditoria de criação e alteração de usuários'>                
            </Card>
        </Card.Group>     
        </Fragment>}
    </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { users, settings } = state;
  return {
    me: users.me || null,
    settings: settings.globalSettings || null,
  };
}

const connectedReportIndexScreen = connect(mapStateToProps)(ReportIndexScreen);
export { connectedReportIndexScreen as ReportIndexScreen };
